import { useRef, useState } from "react";
import { Upload, Loader2, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../../lib/api";

export const ImageUploader = ({ value, onChange, testid = "image-uploader" }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const pick = () => inputRef.current?.click();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-start gap-3" data-testid={testid}>
      <div className="flex h-16 w-24 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-black/10 bg-gray-50">
        {value ? (
          <img src={value} alt="preview" className="h-full w-full object-cover" />
        ) : (
          <ImageIcon className="h-5 w-5 text-gray-300" />
        )}
      </div>
      <div className="flex-1 space-y-2">
        <button
          type="button"
          onClick={pick}
          disabled={uploading}
          data-testid={`${testid}-btn`}
          className="inline-flex items-center gap-2 rounded-full bg-navy px-4 py-2 text-xs font-bold text-white hover:bg-navy-700 disabled:opacity-60"
        >
          {uploading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload size={14} />}
          {uploading ? "Uploading…" : "Upload from computer"}
        </button>
        <input
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="…or paste an image URL"
          className="w-full rounded-full border border-black/10 bg-white px-3.5 py-2 text-xs text-navy outline-none focus:border-navy focus:ring-2 focus:ring-navy/15"
        />
      </div>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/gif,image/webp" onChange={handleFile} className="hidden" data-testid={`${testid}-input`} />
    </div>
  );
};
